export default {
	af_ZA: {
		hash: "14e49a99eb1e758d5e6da8043f43f7bb116d321957d2d559f1f37b65f21e2bb0",
		name: "Afrikaans (Suid-Afrika)",
	},
	ar_SA: { hash: "2b81abcc4d6329e518fd5197df535ea8f78d3b0f7af052c266937586086eb0ba", name: "اللغة العربية" },
	be_BY: { hash: "0293d7571b5b65a55d2ecb7b14a3e1b03fe57a2d1b0f93387ab9dc5b3fbf43e3", name: "Беларускі (Беларусь)" },
	bg_BG: {
		hash: "ae8f5bad824ed5c3d191cef3d06ff06ddf65c9531df301ca793e26aaf7bf4d6b",
		name: "English (United States)",
	},
	ca_ES: { hash: "d9e93b134ebaf80af9b8a7d36ae5b253a3049789d0b504beb1de13ae4d7e3403", name: "Català (Catalunya)" },
	cs_CZ: { hash: "e1a16436805345c6800704cc1dfc3322f67fac6c22c64258f0242435843f75c7", name: "Čeština (Česko)" },
	da_DK: { hash: "7db9b77335e8c9e2d809ae1d9a66ab31e0678db0c77313a69f4de480f2672333", name: "Dansk (Danmark)" },
	de_AT: { hash: "791330385b3183b18300b7b7988d7d5c3f6cb0cee7c182517d4b966569377b06", name: "Deitsch (Österreich)" },
	de_DE: { hash: "f0dbbc9f7219b59af8fd76d94c687d91df7649fdf4b83dc2f1cde1d2eb94c8e7", name: "Deutsch (Deutschland)" },
	el_GR: { hash: "e600edf33746e64a00ee676811b1c852990fbc219b71e14b24c03a0319397dcd", name: "Ελληνικά (Ελλάδα)" },
	en_GB: {
		hash: "35b2802642f0d4d54e2b236d1e7fe48d77f8039cb9ccbfa59d53d35ce4b1bd10",
		name: "English (United Kingdom)",
	},
	en_PT: { hash: "ca951543acf9b9e2dde121039714b5c6a2f9d217c53b326cd5a4a3d2b81190fa", name: "English (Pirate)" },
	en_US: {
		hash: "f06acbb1c37df2a754f2d7de9460d3b0e653f5bbbc830ea87475869c54ace08b",
		name: "English (United States)",
	},
	es_419: { hash: "fc996e46864a65e5415239784192f6b64cb51fc019d06d1ee6040bfdaf261687", name: "Español (Latino)" },
	es_ES: { hash: "a38da12a298e7b7caf367f6cf8a834c37a1734f864551fc990e0f08aa485fbe7", name: "Español (España)" },
	et_EE: { hash: "4359f8f78743230d43e590a779f4c1ff7d94a5f6fc87f8602682bcdf5b9b0342", name: "Eesti keel (Eesti)" },
	fa_IR: { hash: "79584ce90a48c8570713706dac70a93caac10d75b450953c6ea2ce9d06d4c036", name: "فارسی" },
	fi_FI: { hash: "ec16351751d3a46df7603cb98f4b9acd954c39dea30567822289039f793f3f7a", name: "Suomi (Suomi)" },
	fr_FR: { hash: "03d0e52eec9743eb1a94be547caff048b1666d1c7734bf7656a0565e82410cfa", name: "Français (France)" },
	ga_IE: { hash: "fd0e21f70ca4a1907a1d8c420d0ff3ffcae88d8949507476c7bf486a029de79f", name: "Gaeilge (Éireann)" },
	he_IL: { hash: "5d3801be54856ba7a148705610c6320a8b2cdfe8f29a39cb53c395fc9fdf8182", name: "עברית (ישראל)" },
	hi_IN: {
		hash: "ae8f5bad824ed5c3d191cef3d06ff06ddf65c9531df301ca793e26aaf7bf4d6b",
		name: "English (United States)",
	},
	hu_HU: { hash: "e5dbdab558a57f40e4d722341caca9e030f70327223f3d67a888eb0fd9d04e4f", name: "Magyar (Magyarország)" },
	it_IT: { hash: "c9a0f9f62a2264c39b025033de3dd6717760039710383f016f83b2f706ca9ae6", name: "Italiano (Italia)" },
	ja_JP: { hash: "5cdfd05ce83f5e3d16d393f53ba2ce0a0e3fb7c70c20cddfa4806b3e5ee4044d", name: "日本語 (日本)" },
	ka_GE: { hash: "93f07cfa6aa1c839af3b43e26619eddb56ddc06dc13e5d7678437b0a47c04f9a", name: "ქართული (საქართველო)" },
	kk_KZ: { hash: "3bc969810826679148908648c5caabfe84606fd5aa17ff655aa001cca01e4d80", name: "Қазақ тілі (Қазақстан)" },
	ko_KR: { hash: "d537c154cad63caaf9bcd946bc716a93783494bd52a11c686dcba4a6702d66f2", name: "한국어 (대한민국)" },
	nb_NO: { hash: "27f3f1d7addfd6d1619b2e12ed2f88ff21a51563fcb712ecc78f50f5a7ee8e00", name: "Norsk bokmål (Norge)" },
	nl_NL: { hash: "ea737298927e2cacb8db8c1fbeb033299dfb7f5a08c1663d9e32abbfdf5d0c00", name: "Nederlands (Nederland)" },
	nn_NO: { hash: "469024778b949b3e8c48e5789a60a35551407167d40b03163a4c054bb42882ee", name: "Norsk nynorsk (Noreg)" },
	pl_PL: { hash: "1d6df98313991b1039b9272d99d3da10f8dd046ee81bcb3c942abe66a72e03dc", name: "Polski (Polska)" },
	pt_BR: { hash: "0bffad7de35d78bed6d3fd4bb3db807c3ed2b00df271f59e6efca7d23c159ddc", name: "Português (Brasil)" },
	pt_PT: { hash: "2a494034c22245a4cbda925c5bfb9d0265ea02f48cc32bbf290e46d6578647c8", name: "Português (Portugal)" },
	ro_RO: { hash: "f11a7979a76aec58c4acf460c636fc156e49281fe1a986416c4913788eb15671", name: "Română (România)" },
	ru_RU: { hash: "f5e8cda57326eca949389795bba05f6458d5473dc8a98ffe91e0f85e4ac96528", name: "Русский (Россия)" },
	sq_AL: { hash: "3ac165fe4ba68c06c29b7cbd8474816dac6e49fe09ef1a5f029ec0a1491009ec", name: "Shqip (Shqipëri)" },
	sr_SP: { hash: "e8a70ca389e7cb3679f1eb01d6e0e6f670298ad68ff7d1c4d69823a7714e33fb", name: "Српски (Србија)" },
	sv_SE: { hash: "4f26ed36b4c5ed37b7b41f4bc21fc9e3902ba3e0fc8137b8a565dfcf52ffac95", name: "Svenska (Sverige)" },
	th_TH: {
		hash: "ae8f5bad824ed5c3d191cef3d06ff06ddf65c9531df301ca793e26aaf7bf4d6b",
		name: "English (United States)",
	},
	tr_TR: { hash: "e7a77161b7581092ca704b22f13cdf44b9fa01ea79387e8bdf2c34502a85c3c6", name: "Türkçe (Türkiye)" },
	uk_UA: { hash: "081f95776bdfae85c01ca6631c5677f1310f3a8954246dcb49da8006261c68ca", name: "Українська (Україна)" },
	vi_VN: { hash: "21678b7c971af5587e2fee1373e879559e4ac309ba5d5870887dbfe890ad0305", name: "Tiếng Việt (Việt Nam)" },
	zh_CN: {
		hash: "ae8f5bad824ed5c3d191cef3d06ff06ddf65c9531df301ca793e26aaf7bf4d6b",
		name: "English (United States)",
	},
	zh_TW: {
		hash: "ae8f5bad824ed5c3d191cef3d06ff06ddf65c9531df301ca793e26aaf7bf4d6b",
		name: "English (United States)",
	},
} as { [key: string]: { hash: string; name: string } };
